<template>
	<div class="mouse" title="Scroll to view more!"></div>
</template>

<script>
	import { Vue, Component } from "vue-property-decorator";

	export default class ScrollDownIndicator extends Vue{

	}
</script>

<style scoped>
	.mouse{
		position: relative;
		min-width: 20px;
		width: 20px;
		min-height: 30px;
		border: 2px solid #0f141e;
		border-radius: 10px;
	}

	.mouse::after{
		content: '';
		width: 4px;
		height: 6px;
		background: #0f141e;
		margin-left: 6px;
		top: 4px;
		border-radius: 2px;
		-webkit-animation-duration: 1.5s;
		animation-duration: 1.5s;
		-webkit-animation-iteration-count: infinite;
		animation-iteration-count: infinite;
		-webkit-animation-name: scroll;
		animation-name: scroll;
		position: absolute;
	}

	@keyframes scroll {
		0% {
			opacity: 1;
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}

		50% {
			opacity: 1;
			-webkit-transform: translateY(7px);
			transform: translateY(7px)
		}
	}
</style>